import * as React from 'react';
import { PageModel } from '../../../models';
import Controller, { IAbstractDashboardControllerProps } from '../common/CommonDashboardController';
import View from './PrivacyView';

interface IPrivacyViewControllerState extends Interfaces.IViewControllerState {
    privacy: PageModel
    snackbarText: string
}

class PrivacyViewController<P, S> extends Controller<P & IPrivacyViewControllerState, S & IPrivacyViewControllerState> {

    public static defaultProps: Partial<IAbstractDashboardControllerProps> = {
        title: 'Политика конфиденциальности'
    }

    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            privacy: {},
            snackbarText: ''
        } as any;
    }

    public async fia_componentWillMount() {
        this.setState({ loading: true });
        await this.loadPrivacy();
    }


    public async loadPrivacy() {
        const privacy = await PageModel.getPrivacyPage();
        this.setState({ privacy, loading: false });
    }

    public async onSavePrivacy() {
        this.setState({ loading: true });
        const { privacy } = this.state;
        await privacy.savePrivacyPage();
        this.setState({ snackbarText: 'Сохранено', loading: false });
    }

    public dashboard_render(): JSX.Element {
        const { loading, privacy, snackbarText } = this.state;
        return (
            <View
                snackbarText={snackbarText}
                accessAvailable={this.accessAvailable}
                model={privacy.model}
                loading={loading}
                onSave={() => this.onSavePrivacy()}
            />
        )
    }
}

export default PrivacyViewController;



// WEBPACK FOOTER //
// ./src/app/dashboard/privacy/PrivacyViewController.tsx